export const LANG_STORAGE_KEY = 'hknews_lang';

export const translations = {
  en: {
    chooseLanguage: 'Choose Your Language',
    kannada: 'ಕನ್ನಡ',
    english: 'English',
    home: 'Home',
    categories: 'Categories',
    districts: 'Districts',
    epaper: 'e-Paper',
    contact: 'Contact',
    connect: 'Connect',
    developer: 'Developer',
    search: 'Search',
    searchPlaceholder: 'Search news…',
    latestNews: 'Latest News',
    breakingNews: 'Breaking News',
    topStories: 'Top Stories',
    featured: 'Featured',
    relatedNews: 'Related News',
    readMore: 'Read more',
    share: 'Share',
    downloadPdf: 'Download PDF',
    digitalEdition: 'Digital Edition',
    advertisements: 'Advertisements',
    newsletter: 'Newsletter',
    subscribe: 'Subscribe',
    emailPlaceholder: 'Enter your email',
    follow: 'Follow',
    sendMessage: 'Send Message',
    name: 'Name',
    email: 'Email',
    message: 'Message',
    phone: 'Phone',
    address: 'Address',
    organization: 'Organization',
    mapPlaceholder: 'Map placeholder',
    connectWithUs: 'Connect With Us',
    contactUs: 'Contact Us',
    aboutDeveloper: 'About the Developer',
    technologies: 'Technologies',
    projectOverview: 'Project overview',
    connectSection: 'Connect',
    photoPlaceholder: 'Professional photo placeholder',
    qrPlaceholder: 'QR placeholder',
    noSocialConfigured: 'Social links are not configured yet.',
    articleNotFound: 'Article Not Found',
    backToHome: '← Back to Home',
    loading: 'Loading…',
    views: 'views',
    minRead: 'min read',
    tags: 'Tags',
    reporter: 'Reporter',
    notPublished: 'Not published',
    weather: 'Weather',
    more: 'More',
    login: 'Login',
    logout: 'Logout',
    developedBy: 'Developed by',
    allRights: 'All rights reserved.',
    fillRequired: 'Please fill all fields',
    openingEmail: 'Opening your email client…',
    subscribed: 'Successfully subscribed to newsletter!',
    linkCopied: 'Link copied to clipboard',
    pdfUnavailable: 'PDF unavailable',
    pdfMissingHint: 'This edition file could not be loaded.',
    language: 'Language',
    epaperTeaser: "Read today's digital edition and browse the archive.",
    whatsapp: 'WhatsApp',
  },
  kn: {
    chooseLanguage: 'ನಿಮ್ಮ ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    kannada: 'ಕನ್ನಡ',
    english: 'English',
    home: 'ಮುಖಪುಟ',
    categories: 'ವಿಭಾಗಗಳು',
    districts: 'ಜಿಲ್ಲೆಗಳು',
    epaper: 'ಇ-ಪೇಪರ್',
    contact: 'ಸಂಪರ್ಕ',
    connect: 'ಸಂಪರ್ಕಿಸಿ',
    developer: 'ಡೆವಲಪರ್',
    search: 'ಹುಡುಕಿ',
    searchPlaceholder: 'ಸುದ್ದಿ ಹುಡುಕಿ…',
    latestNews: 'ಇತ್ತೀಚಿನ ಸುದ್ದಿ',
    breakingNews: 'ತುರ್ತು ಸುದ್ದಿ',
    topStories: 'ಪ್ರಮುಖ ಸುದ್ದಿಗಳು',
    featured: 'ವಿಶೇಷ',
    relatedNews: 'ಸಂಬಂಧಿತ ಸುದ್ದಿಗಳು',
    readMore: 'ಮತ್ತಷ್ಟು ಓದಿ',
    share: 'ಹಂಚಿಕೊಳ್ಳಿ',
    downloadPdf: 'PDF ಡೌನ್‌ಲೋಡ್',
    digitalEdition: 'ಡಿಜಿಟಲ್ ಆವೃತ್ತಿ',
    advertisements: 'ಜಾಹೀರಾತುಗಳು',
    newsletter: 'ನ್ಯೂಸ್‌ಲೆಟರ್',
    subscribe: 'ಚಂದಾದಾರರಾಗಿ',
    emailPlaceholder: 'ಇಮೇಲ್ ನಮೂದಿಸಿ',
    follow: 'ಅನುಸರಿಸಿ',
    sendMessage: 'ಸಂದೇಶ ಕಳುಹಿಸಿ',
    name: 'ಹೆಸರು',
    email: 'ಇಮೇಲ್',
    message: 'ಸಂದೇಶ',
    phone: 'ದೂರವಾಣಿ',
    address: 'ವಿಳಾಸ',
    organization: 'ಸಂಸ್ಥೆ',
    mapPlaceholder: 'ನಕ್ಷೆ ಪ್ಲೇಸ್‌ಹೋಲ್ಡರ್',
    connectWithUs: 'ನಮ್ಮೊಂದಿಗೆ ಸಂಪರ್ಕಿಸಿ',
    contactUs: 'ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ',
    aboutDeveloper: 'ಡೆವಲಪರ್ ಬಗ್ಗೆ',
    technologies: 'ತಂತ್ರಜ್ಞಾನಗಳು',
    projectOverview: 'ಯೋಜನೆ ಅವಲೋಕನ',
    connectSection: 'ಸಂಪರ್ಕ',
    photoPlaceholder: 'ವೃತ್ತಿಪರ ಫೋಟೋ ಪ್ಲೇಸ್‌ಹೋಲ್ಡರ್',
    qrPlaceholder: 'QR ಪ್ಲೇಸ್‌ಹೋಲ್ಡರ್',
    noSocialConfigured: 'ಸಾಮಾಜಿಕ ಲಿಂಕ್‌ಗಳು ಇನ್ನೂ ಕಾನ್ಫಿಗರ್ ಆಗಿಲ್ಲ.',
    articleNotFound: 'ಲೇಖನ ಕಂಡುಬಂದಿಲ್ಲ',
    backToHome: '← ಮುಖಪುಟಕ್ಕೆ ಹಿಂತಿರುಗಿ',
    loading: 'ಲೋಡ್ ಆಗುತ್ತಿದೆ…',
    views: 'ವೀಕ್ಷಣೆಗಳು',
    minRead: 'ನಿಮಿಷ ಓದು',
    tags: 'ಟ್ಯಾಗ್‌ಗಳು',
    reporter: 'ವರದಿಗಾರ',
    notPublished: 'ಪ್ರಕಟವಾಗಿಲ್ಲ',
    weather: 'ಹವಾಮಾನ',
    more: 'ಇನ್ನಷ್ಟು',
    login: 'ಲಾಗಿನ್',
    logout: 'ಲಾಗ್‌ಔಟ್',
    developedBy: 'ಅಭಿವೃದ್ಧಿಪಡಿಸಿದವರು',
    allRights: 'ಎಲ್ಲಾ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.',
    fillRequired: 'ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಕ್ಷೇತ್ರಗಳನ್ನು ಭರ್ತಿ ಮಾಡಿ',
    openingEmail: 'ನಿಮ್ಮ ಇಮೇಲ್ ಕ್ಲೈಂಟ್ ತೆರೆಯುತ್ತಿದೆ…',
    subscribed: 'ನ್ಯೂಸ್‌ಲೆಟರ್‌ಗೆ ಯಶಸ್ವಿಯಾಗಿ ಚಂದಾ ಮಾಡಲಾಗಿದೆ!',
    linkCopied: 'ಲಿಂಕ್ ನಕಲಿಸಲಾಗಿದೆ',
    pdfUnavailable: 'PDF ಲಭ್ಯವಿಲ್ಲ',
    pdfMissingHint: 'ಈ ಆವೃತ್ತಿ ಫೈಲ್ ಅನ್ನು ಲೋಡ್ ಮಾಡಲಾಗಲಿಲ್ಲ.',
    language: 'ಭಾಷೆ',
    epaperTeaser: 'ಇಂದಿನ ಡಿಜಿಟಲ್ ಆವೃತ್ತಿ ಓದಿ ಮತ್ತು ಆರ್ಕೈವ್ ಬ್ರೌಸ್ ಮಾಡಿ.',
    whatsapp: 'ವಾಟ್ಸಾಪ್',
  },
};

export const t = (lang, key) => {
  const table = translations[lang] || translations.en;
  return table[key] || translations.en[key] || key;
};

/** Pick localized article fields with fallback */
export const localizeArticle = (article, lang) => {
  if (!article) return article;
  const kn = lang === 'kn';
  return {
    ...article,
    displayTitle: kn
      ? (article.titleKannada || article.title)
      : (article.title || article.titleKannada),
    displayExcerpt: article.excerpt || '',
    displayContent: kn
      ? (article.contentKannada || article.content || '')
      : (article.content || article.contentKannada || ''),
  };
};

export const localizeName = (item, lang) => {
  if (!item) return '';
  const english = String(item.name || item.nameEn || '').trim();
  const kannada = String(item.nameKannada || item.name_kn || item.nameKn || '').trim();
  if (lang === 'kn') return kannada || english;
  return english || kannada;
};
